  <template>
  <div class="rs-listing__festival">
    <div class="rs-listing__festival">
      <div class="rs-listing__festival__info__selector">
        <div
          class="rs-listing__festival__info__selector__modal"
          v-if="isModalOpen"
        ></div>
      </div>
    </div>
    <div class="rs-listing__festival__level1">
      <div class="rs-listing__festival__selector">
        <button
          class="rs-listing__festival__selector__button"
          @click="toggleModal"
        >
          <span
            v-html="
              selectedFestival
                ? getFestivalObjectFromSlug(selectedFestival).name
                : 'Select Festival'
            "
          ></span>
          <svg
            width="12.908"
            height="9.828"
            viewBox="0 0 12.908 9.828"
            :class="isModalOpen && 'rs-listing__rotate180'"
          >
            <path
              d="M8.848-3.836l-6.832-6.44,6.832-6.468h3l-6.86,6.468,6.86,6.44Z"
              transform="translate(16.744 11.844) rotate(-90)"
              fill="#652981"
            />
          </svg>
        </button>
        <div class="rs-listing__festival__selector__modal" v-if="isModalOpen">
          <div class="rs-listing__festival__selector__modal__level0">
            <button
              class="rs-listing__festival__selector__modal__buttonall"
              :class="
                !selectedFestival &&
                'rs-listing__festival__selector__modal__selected'
              "
              @click="showAll"
            >
              All
            </button>
            <button
              v-for="festival in fetchedFestivals"
              :key="festival.slug"
              :class="
                selectedFestival === festival.slug &&
                'rs-listing__festival__selector__modal__selected'
              "
              @click="selectFestival(festival)"
            >
              {{ festival.name }}
            </button>
          </div>
        </div>
      </div>
      <div class="rs-listing__festival__link-to-fe__desktop">
        <a href="/jewish-festivals/"
          >View the Festivals Archive &gt;</a
        >
      </div>
    </div>

    <div class="rs-listing__festival__level2">
      <div class="rs-listing__festival__description">
        <p v-if="selectedFestival">
          {{ getFestivalObjectFromSlug(selectedFestival).description }}
        </p>
        <p v-else>
          Select a festival to explore...
          <!-- “The Jewish calendar is so fundamental to the continued vitality of
          the Jewish people. It sets out a weekly, monthly and yearly schedule
          of sacred times. The Torah forces us to remember what contemporary
          culture regularly forgets: that our lives must have dedicated times
          when we focus on the things that give life a meaning. And because we
          are social animals, the most important times are the ones we share.
          The Jewish calendar is precisely that: a structure of shared time.” &mdash;
          Rabbi Sacks -->
        </p>
      </div>
      <div
        class="rs-listing__festival__image"
        v-html="
          selectedFestival
            ? getFestivalObjectFromSlug(selectedFestival).featured_image
            : '&nbsp;'
        "
      ></div>
    </div>
    <div class="rs-listing__festival__link-to-fe__mobile">
      <a href="/jewish-festivals/">Festivals Archive &gt;</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fetchedFestivals: Array,
    selectedFestival: String,
  },
  data: function () {
    return {
      isModalOpen: false,
    };
  },
  mounted() {
    //
  },
  watch: {
    //
  },
  methods: {
    showAll() {
      this.$emit("selected-festival-change", null);
      this.toggleModal();
    },
    selectFestival(festival) {
      this.$emit("selected-festival-change", festival ? festival.slug : null);
      this.toggleModal();
    },
    toggleModal() {
      this.isModalOpen = !this.isModalOpen;
    },
    getFestivalObjectFromSlug(festivalSlug) {
      let _festivalObj = null;
      this.fetchedFestivals.forEach((loopFestival) => {
        if (loopFestival.slug === festivalSlug) {
          _festivalObj = loopFestival;
        }
      });
      return _festivalObj;
    },
  },
};
</script>
